import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Tooltip, withStyles } from '@material-ui/core'
import { Info, AddCircleOutline } from '@material-ui/icons'
import Button from 'components/theme/Button'
import { changeNewStageName, addStage } from 'actions/campaign/addOrEdit'
import language from 'utils/vast-languagepack'

export default connect(
  state => ({ text: state.campaign.addOrEdit.newStageNameText }),
  dispatch => bindActionCreators({ changeNewStageName, addStage }, dispatch)
)(
  withStyles(theme => ({
    button: {
      position: 'absolute',
      right: 5,
      top: 6
    },
    info: {
      width: 35,
      height: 35,
      marginLeft: '-3px',
      marginBottom: '-16px',
      fill: '#707070',
      cursor: 'pointer'
    },
    textField: {
      backgroundColor: '#fff',
      width: 'calc(100% - 49px)',
      display: 'inline-block',
      marginLeft: 17,
      borderRadius: 35,
      paddingLeft: 16,
      paddingTop: 10,
      height: 48,
      borderWidth: 1,
      border: 'solid #707070'
    },
    input: {
      fontSize: 15,
      borderWidth: 0,
      width: 'calc(100% - 207px)',
      '&:focus': {
        outline: 'none'
      }
    }
  }))(({ classes, text, changeNewStageName, addStage }) => (
    <div style={{ position: 'relative', marginBottom: 15 }}>
      <Tooltip title={language.campaign.helperText.newStageName}>
        <Info className={classes.info} />
      </Tooltip>
      <div className={classes.textField}>
        <input
          value={text}
          onChange={e => changeNewStageName(e.target.value)}
          className={classes.input}
          type='text'
          placeholder={language.campaign.helperText.enterNewStageName}
        />
      </div>
      <Button
        onClick={() => addStage(text)}
        color='secondary'
        variant='contained'
        className={classes.button}
      >
        <AddCircleOutline style={{ marginRight: 5 }} />
        {language.campaign.add.newFunnelStageText}
      </Button>
    </div>
  ))
);
